const name = 'Position';
const properties = {
    groups: ['animation'],
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        from: {
            type: 'object',
            properties: {
                left: {
                    type: 'numberLike',
                },
                top: {
                    type: 'numberLike',
                },
                x: {
                    type: 'numberLike',
                },
                y: {
                    type: 'numberLike',
                },
                z: {
                    type: 'numberLike',
                },
                bezier: {
                    type: 'numberLike',
                },
            },
        },
        to: {
            type: 'object',
            properties: {
                left: {
                    type: 'numberLike',
                },
                top: {
                    type: 'numberLike',
                },
                x: {
                    type: 'numberLike',
                },
                y: {
                    type: 'numberLike',
                },
                z: {
                    type: 'numberLike',
                },
                bezier: {
                    type: 'string',
                },
            },
        },
    },
};
/**
 * Position animation object
 */
function animate(kit, elements, duration, delay, { from = {}, to = {}, ease = 'Sine.easeIn', ...params } = {}) {
    const sequence = kit.sequence(params);
    sequence.add(kit.animate('BasePosition', elements, duration, delay, {
        from,
        to,
        ease,
    }));
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=position.js.map